import { createContext } from 'react';

import { Organization } from '@totem/components/orgManagement/types';
import {
  User,
  UserQueryResults,
  UsersConnectionInput,
} from '@totem/components/users/container/types';

interface Context {
  input: UsersConnectionInput;
  setInput: (input: UsersConnectionInput) => void;
  loading: boolean;
  organization: Organization;
  userData: UserQueryResults;
  totalRecords: number;
  onAction?: (action: string, user: User) => void;
}

export default createContext<Context>({
  input: {},
  setInput: () => {},
  loading: false,
  organization: null,
  userData: null,
  totalRecords: 0,
  onAction: null,
});
